var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMuteIconinline = function SvgMuteIconinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m21.1 22.175-3.3-3.3q-.7.499-1.512.863a9 9 0 0 1-1.688.562v-1.55q.574-.175 1.113-.387.537-.213 1.012-.563L12.6 13.65v5.925l-5-5h-4v-6h3.9L2 3.075 3.075 2l19.1 19.075zm-.9-5.8L19.125 15.3q.5-.85.738-1.8a8 8 0 0 0 .237-1.95q0-2.575-1.5-4.613-1.5-2.037-4-2.587V2.8q3.1.7 5.05 3.138t1.95 5.612q0 1.275-.35 2.5a8.8 8.8 0 0 1-1.05 2.325m-3.35-3.35-2.25-2.25v-3.25a4.15 4.15 0 0 1 1.838 1.65q.662 1.1.662 2.4a4.3 4.3 0 0 1-.25 1.45m-4.25-4.25-2.6-2.6 2.6-2.6zm-1.5 7.15v-3.75l-2.1-2.1H5.1v3h3.15z"
  })));
};
export default SvgMuteIconinline;